export default __webpack_public_path__ + "static/media/photo5.d1addb5b.jpg";